/**
 * Las notas de los campamentos piden alergias y necesidades especiales del niño o la niña: datos de
 * salud (art. 9 RGPD). Solo se envían con el consentimiento explícito de la familia (art. 9.2.a), en
 * una casilla propia, separada de las condiciones y sin marcar de antemano. En los cumpleaños no:
 * quien reserva no puede consentir por los invitados, así que se piden las alergias sin nombres.
 */
export const faltaConsentimientoSalud = (notas: string | undefined, consentimiento: boolean | undefined) =>
  Boolean(notas?.trim()) && !consentimiento;

export const TEXTOS_SALUD: Record<string, { casilla: string; error: string; masInfo: string; pestanaNueva: string }> = {
  es: {
    casilla:
      "Si he indicado alergias, intolerancias o necesidades especiales, consiento que Gándara International School trate esos datos de salud solo para atender a mi hijo o hija durante la actividad. Puedo retirar este consentimiento en cualquier momento.",
    error: "Para enviar información de salud en las notas, marca esta casilla (o borra esa información).",
    masInfo: "Más información",
    pestanaNueva: "(se abre en una pestaña nueva)",
  },
  en: {
    casilla:
      "If I have listed allergies, intolerances or special needs, I consent to Gándara International School processing that health information only to look after my child during the activity. I can withdraw this consent at any time.",
    error: "To send health information in the notes, tick this box (or remove that information).",
    masInfo: "More information",
    pestanaNueva: "(opens in a new tab)",
  },
  pt: {
    casilla:
      "Se indiquei alergias, intolerâncias ou necessidades especiais, consinto que a Gándara International School trate esses dados de saúde apenas para cuidar do meu filho ou da minha filha durante a atividade. Posso retirar este consentimento a qualquer momento.",
    error: "Para enviar informação de saúde nas notas, marque esta caixa (ou apague essa informação).",
    masInfo: "Mais informação",
    pestanaNueva: "(abre num novo separador)",
  },
  fr: {
    casilla:
      "Si j'ai indiqué des allergies, des intolérances ou des besoins particuliers, je consens à ce que Gándara International School traite ces données de santé uniquement pour s'occuper de mon enfant pendant l'activité. Je peux retirer ce consentement à tout moment.",
    error: "Pour envoyer des informations de santé dans les notes, cochez cette case (ou supprimez ces informations).",
    masInfo: "Plus d'informations",
    pestanaNueva: "(s'ouvre dans un nouvel onglet)",
  },
};

export const textosSalud = (idioma: string) => TEXTOS_SALUD[idioma] || TEXTOS_SALUD.es;
